(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Intersection Observer: staggered scroll-reveal ────── */
  function buildRevealObserver() {
    return new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('prfd-visible');
        revealObs.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });
  }
  var revealObs = buildRevealObserver();

  function attachReveal(selector, stepMs, maxMs) {
    document.querySelectorAll(selector).forEach(function (el, i) {
      el.classList.add('prfd-reveal');
      if (!reducedMotion) {
        el.style.transitionDelay = Math.min(i * stepMs, maxMs) + 'ms';
      }
      revealObs.observe(el);
    });
  }

  /* ── Stat counter animation ─────────────────────────────── */
  function parseStatValue(text) {
    var clean = text.trim();
    var digits = clean.replace(/[\s,.]/g, '').replace(/[^0-9]/g, '');
    var num = parseInt(digits, 10);
    if (isNaN(num) || num < 2) return null;
    var suffix = clean.replace(/[0-9\s,.]/g, '');
    return { num: num, suffix: suffix, original: clean };
  }

  function runCounter(el, num, suffix) {
    var duration = 1800;
    var startTime = null;
    function tick(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * num);
      el.textContent = current.toLocaleString('nb-NO') + suffix;
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = num.toLocaleString('nb-NO') + suffix;
      }
    }
    requestAnimationFrame(tick);
  }

  function setupCounters() {
    document.querySelectorAll('.machine-hero__stat-value').forEach(function (el) {
      var parsed = parseStatValue(el.textContent);
      if (!parsed) return;
      var triggered = false;
      var cObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || triggered) return;
          triggered = true;
          cObs.unobserve(el);
          if (reducedMotion) return;
          runCounter(el, parsed.num, parsed.suffix);
        });
      }, { threshold: 0.6 });
      cObs.observe(el);
    });
  }

  /* ── Heading highlight draw-on underline ────────────────── */
  function setupHighlightUnderline() {
    document.querySelectorAll('.machine-hero__heading-highlight').forEach(function (el) {
      el.classList.add('prfd-highlight');
    });
  }

  /* ── Popular section: CSS transition instead of animation ── */
  function setupPopularReveal() {
    var pop = document.querySelector('.machine-hero__popular');
    if (!pop) return;
    if (reducedMotion) {
      pop.style.opacity = '1';
      pop.style.transition = 'none';
      return;
    }
    // Small rAF delay so the transition fires after paint (not on opacity:0 init)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pop.classList.add('prfd-pop-ready');
      });
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    attachReveal('.brand-grid-section__item', 75, 500);
    setupCounters();
    setupHighlightUnderline();
    setupPopularReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
